/// <reference types="@types/googlemaps" />

import {Component, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AnalysisService} from '../services/analysis.service';
import {ToastrService} from 'ngx-toastr';
import {ModuleService} from '../services/module.service';
import {ModalSurveyRoiComponent} from '../modal-survey-roi/modal-survey-roi.component';

import * as FileSaver from 'file-saver';
import {ITimeline} from '../interfaces/timeline';
import {ITimelineItem} from '../interfaces/timelineItem';


@Component({
  selector: 'app-roi',
  templateUrl: './roi.component.html',
  styleUrls: ['./roi.component.css']
})
export class RoiComponent implements OnInit {

  constructor(
    private router: Router,
    private modalService: NgbModal,
    private translate: TranslateService,
    private analysisService: AnalysisService,
    private moduleService: ModuleService,
    private toastr: ToastrService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
  ) {
    this.matIconRegistry.addSvgIcon('back', this.domSanitizer.bypassSecurityTrustResourceUrl(this.homeImage));
    this.matIconRegistry.addSvgIcon('all', this.domSanitizer.bypassSecurityTrustResourceUrl(this.summaryImage));
    this.matIconRegistry.addSvgIcon('Analysis', this.domSanitizer.bypassSecurityTrustResourceUrl(this.analysisImage));
    this.matIconRegistry.addSvgIcon('MDI', this.domSanitizer.bypassSecurityTrustResourceUrl(this.mdiImage));
    this.matIconRegistry.addSvgIcon('PPR', this.domSanitizer.bypassSecurityTrustResourceUrl(this.pprImage));
    this.matIconRegistry.addSvgIcon('ROI', this.domSanitizer.bypassSecurityTrustResourceUrl(this.roiImage));
  }

  // LocalStorage Elements.
  localFacilities = localStorage.getItem('localFacilities');
  localID = localStorage.getItem('localID');
  localModules = localStorage.getItem('localModules');

  timelineMessage = '';

  id = JSON.parse(this.localID);
  facilities = JSON.parse(this.localFacilities);
  modules = JSON.parse(this.localModules);
  currentFacility = this.facilities[this.id];

  // Icon NavBar
  markerImage: any = require('../image/logo/locationIcon.png');
  homeImage: any = require('../image/navbar/backHomeIcon.svg');
  summaryImage: any = require('../image/navbar/summary.svg');
  analysisImage: any = require('../image/navbar/analysis.svg');
  roiImage: any = require('../image/navbar/roi.svg');
  mdiImage: any = require('../image/navbar/mdi.svg');
  pprImage: any = require('../image/navbar/ppr.svg');

  lng: any;
  lat: any;
  zoom: number;

  timeline: ITimeline;

  itemTimeline: Array<ITimelineItem> = [];
  currentPage = 0;
  itemsNumberPerPage = 10;

  modalReference: any;

  isOpen: boolean;
  _opened = false;

  // Variable that defines the state of the plan
  planStateSaved: boolean;

  // Plan and report date
  reportAnalisysDate: string;
  planInterventDate: string;

  module = 'ROI';
  idElaboration: number;

  titlePdf: string;

  ngOnInit() {
    this.translate.use(localStorage.getItem('localLanguage'));
    this.createGoogleMap();
    this.getTimeline(this.currentPage);
  }

  _toggleSidebar() {
    this._opened = !this._opened;
  }

  cardStructureOpen() {
    this.isOpen = true;
  }

  cardStructureClose() {
    this.isOpen = false;
  }

  // Method used to create a map of current Structure.
  createGoogleMap() {
    if (navigator) {
      this.lng = this.currentFacility.myFacilities.Longitude;
      this.lat = this.currentFacility.myFacilities.Latitude;
      this.zoom = 13;
    }
  }

  // Method used to scrolled Timline of current facility.
  onScroll(event) {
    if ((event.target.scrollHeight - event.target.scrollTop) === event.target.clientHeight) {
      if ((this.timeline.currentPage + 1) * this.timeline.requestItemsNumberPerPage < this.timeline.totalItemsCount) {
        this.currentPage++;
        this.getTimeline(this.currentPage);
      }
    }
  }

  // API Return Timeline
  getTimeline(currentPage: number) {
    // Call Api of Analys service to get Timeline of current facility.
    this.analysisService.getTimeline(this.currentFacility.myFacilities.IdAnalysis, this.modules, currentPage, this.itemsNumberPerPage)
      .subscribe(
        data => {
          this.timeline = data;

          for (const item of this.timeline.items) {
            this.itemTimeline.push(item);
          }

          this.checkedRequest();
          this.checkStateOfItem(this.timeline);
        },
        error => {
          //  this.router.navigate(['/errorPage']);
          this.timelineMessage = error.error;
        }
      );
  }

  // Method that checked request
  checkedRequest() {
    this.moduleService.ceckRequest(this.module, this.currentFacility.myFacilities.IdAnalysis)
      .subscribe(
        data => {
          this.planStateSaved = true;
        },
        error => {
          if (error.status === 409 || error.status === 404) {
            this.planStateSaved = false;
          } else {
            this.router.navigate(['/errorPage']);
          }
        });
  }

  // Method that check status of plan
  checkStateOfItem(timeline: any) {
    for (const itemTimeline of timeline.items) {
      if (itemTimeline.state === 'CompilazioneNonAvviata' || itemTimeline.state === 'CompilazioneParziale' || itemTimeline.state === 'CompilazioneConclusa') {
        this.planInterventDate = this.setDate(new Date(itemTimeline.timestamp));
        break;
      }
    }

    for (const itemTimeline of timeline.items) {
      if ((itemTimeline.state === 'Pubblicato' || itemTimeline.state === 'Concluso' || itemTimeline.state === 'Eseguito')
        && itemTimeline.module === 'ROI') {
        this.idElaboration = itemTimeline.idElaborazioneRef;
        this.reportAnalisysDate = this.setDate(new Date(itemTimeline.timestamp));
        break;
      }
    }
  }

  // Method that set date from timestamp to report item of timeline.
  setDate(timestamp: Date): string {
    const utcDay = timestamp.getHours() !== 0 ? timestamp.getUTCDate() : timestamp.getUTCDate() + 1;
    const utcMonth = timestamp.getUTCMonth() < 11 ? timestamp.getUTCMonth() + 1 : 0;
    const utcYear = timestamp.getUTCMonth() < 11 ? timestamp.getUTCFullYear() : timestamp.getUTCFullYear() + 1;

    return utcDay + '/' + utcMonth + '/' + utcYear;
  }

  // Method used to open Modal of Request ROI.
  openVerticallyCentered(content) {
    this.modalReference = this.modalService.open(content, {centered: true});
  }

  // Method used to close Modal of Request ROI.
  close() {
    this.modalReference.close();
  }

  // API Roi Request.
  roiRequest() {
    this.moduleService.moduleRequest(this.module, this.currentFacility.myFacilities.ID, this.idElaboration)
      .subscribe(
        data => {
          this.currentPage = 0;
          this.itemTimeline = [];
          this.getTimeline(this.currentPage);
          this.close();
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }

  // Method that open modal for fill or read survey of Roi
  openModalSurveyRoi(content, itemState: string, itemTimestamp: string, element) {

    this.planInterventDate = this.setDate(new Date(itemTimestamp));
    const modalRef = this.modalService.open(ModalSurveyRoiComponent, {centered: true, size: 'lg'});
    modalRef.componentInstance.idElaboration = element.idElaborazioneRef;
    modalRef.componentInstance.planInterventDate = this.planInterventDate;
    modalRef.componentInstance.itemState = itemState;

    modalRef.componentInstance.surveyModalEvent.subscribe(event => {
      if (event === 'Partial' || event === 'Complete') {
        this.getTimeline(this.currentPage);
      }
    });
  }

  // API download ROI
  downloadRoi(element) {

    this.moduleService.moduleDownload(this.currentFacility.myFacilities.ID, element.idElaborazioneRef, this.module)
      .subscribe(
        (data) => {

          this.translate.get('ROI_PDF.TITLE').subscribe((res: string) => {
            this.titlePdf = res + ' ' + this.planInterventDate;
          });
          const byteArray = new Uint8Array(atob(data.Base64FileContent).split('').map(char => char.charCodeAt(0)));
          const blob = new Blob([byteArray], {type: data.ContentType});
          FileSaver.saveAs(blob, this.titlePdf + '.pdf');
        },
        error => {
          this.router.navigate(['/errorPage']);
        });
  }
}
